/**
 * Business-size design intelligence — how scale shifts positioning.
 * Keyed by size slug. Additive, pure data.
 */

export const BUSINESS_SIZE_KNOWLEDGE = Object.freeze({
  solo: { asOf: '2026', confidence: 0.6, brandPositioning: ['personal', 'approachable'], premiumCues: ['crafted-detail'] },
  smb: { asOf: '2026', confidence: 0.6, brandPositioning: ['established', 'reliable'] },
  enterprise: { asOf: '2026', confidence: 0.62, brandPositioning: ['credible', 'scaled'], premiumCues: ['precision', 'confident-scale'] },
});
